<app-signin-signup *ngIf="showPhoneVerify"
  title="Start your fundraiser in seconds.<br/> It's free!"
  theme="saf"
  inputLabel="Mobile Number"
  redirectTo="new/saf"
  [showBack]="true"
  [closeOnBack]="true"
  [showFlag]="false"
  [popupView]="true"
  [numberOnly]="true"
  [hideAgree]="true"
  [hideStartFund]="true"
  [noRedirectAfterLogin]="true"
  [firebaseResponseOnlyForNew]="true"
  [showPopup]="true"
  [noRedirectAfterLogin]="true"
  [showOtpSeparate]="true"
  [showInputV2]="true"
  [dialogConfig]="{backdropClass: 'loginSignupBackDrop', disableClose: true}"
/>

<div class="dmsans" *ngIf="!this.vwo.revamp_homepage_nonloggedin_AB()">
  <div *ngIf="userData && (!draftData || draftData?.status_flag === 7)" class="home-v2">
    <app-component-loader [load]="true" selector="app-home-v2"></app-component-loader>
  </div>


  <div *ngIf="!userData || (draftData && draftData?.status_flag !== 7)" class="portrait-view">

    <app-banner></app-banner>

    <div class="desktop_bg">
      <svg xmlns="http://www.w3.org/2000/svg" class="light-blue-bg" preserveAspectRatio="none" width="100%"
        height="1000" viewBox="0 0 1440 1177">
        <defs>
          <linearGradient id="a" x1="135.962%" x2="0%" y1="-37.992%" y2="100%">
            <stop offset="0%" stop-color="#1585F1" />
            <stop offset="100%" stop-color="#01BFBD" />
          </linearGradient>
        </defs>
        <path fill="url(#a)" fill-opacity=".1" fill-rule="evenodd"
          d="M-4 681.45c305.836-27.451 551.741-.82 737.716 79.893 278.963 121.07 395.08 297.738 706.284 297.738v785.495c-321.113 20.78-587.617-53.034-799.511-221.443C428.595 1454.725 213.765 1375.92-4 1386.718V681.45z"
          opacity=".5" transform="translate(0 -671)" />
      </svg>
      <app-trending-fundraiers [freqVisitedCampaigns]="freqVisitedCampaigns"></app-trending-fundraiers>
    </div>

    <div inViewport class="sac-flow-wrapper" (inViewportAction)="loadComponent($event,'sacflow')"
      [inViewportOptions]="{ threshold: [700] }">
      <svg class="d-none d-lg-block" width="360" height="410" viewBox="0 0 360 410" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.07" fill-rule="evenodd" clip-rule="evenodd"
          d="M-7.37723 390.259C155.71 390.259 355 459.737 355 297.017C355 134.297 170.758 5 7.67014 5C-155.417 5 -331 134.297 -331 297.017C-331 459.737 -170.465 390.259 -7.37723 390.259Z"
          fill="url(#paint0_linear)" stroke="url(#paint1_linear)" stroke-width="9" />
        <defs>
          <linearGradient id="paint0_linear" x1="-677.43" y1="209" x2="-320.621" y2="814.928"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#3023AE" />
            <stop offset="1" stop-color="#C86DD7" />
          </linearGradient>
          <linearGradient id="paint1_linear" x1="-677.43" y1="209" x2="-320.621" y2="814.928"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#3023AE" />
            <stop offset="1" stop-color="#C86DD7" />
          </linearGradient>
        </defs>
      </svg>
      <app-sacflow *ngIf="componentInView.sacflow"></app-sacflow>
      <hr class="separator d-lg-none d-md-none" />
    </div>

    <div class="sip_bg">
      <div class="bg-img d-none d-lg-block">
        <img loading="lazy" [attr.data-src]="'/assets/images/sip/oval-pink.png'" [default]="util.defaultImg"
          [class]="userData?.listsubscriptions?.medical?.status_flag?.toString().match('1|2') ? '':'mcd'"
          alt="no images">
      </div>
      <div class="main-content">
        <app-download-app-banner></app-download-app-banner>
      </div>
    </div>


    <div class="causes_bg">
      <div inViewport (inViewportAction)="loadComponent($event,'causes')" [inViewportOptions]="{ threshold: [700] }">
        <app-causes *ngIf="componentInView.causes"></app-causes>
      </div>
      <svg width="240" height="308" viewBox="0 0 240 308" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.1" fill-rule="evenodd" clip-rule="evenodd"
          d="M220 5C338.741 5 435 101.532 435 220.611C435 339.69 416.64 294.643 297.899 294.643C179.158 294.643 5 339.69 5 220.611C5 101.532 101.259 5 220 5Z"
          fill="url(#paint0_linear)" stroke="url(#paint1_linear)" stroke-width="9" />
        <defs>
          <linearGradient id="paint0_linear" x1="5" y1="303" x2="5" y2="5" gradientUnits="userSpaceOnUse">
            <stop stop-color="#FAD961" />
            <stop offset="1" stop-color="#F76B1C" />
          </linearGradient>
          <linearGradient id="paint1_linear" x1="5" y1="303" x2="5" y2="5" gradientUnits="userSpaceOnUse">
            <stop stop-color="#FAD961" />
            <stop offset="1" stop-color="#F76B1C" />
          </linearGradient>
        </defs>
      </svg>
    </div>


    <div class="whatweoffer_bg">
      <div inViewport style="min-height:500px;" (inViewportAction)="loadComponent($event,'crowdfunding')"
        [inViewportOptions]="{ threshold: [700] }">
        <app-crowdfunding *ngIf="componentInView.crowdfunding"></app-crowdfunding>
      </div>
    </div>

    <div inViewport style="min-height:500px;" (inViewportAction)="loadComponent($event,'successtories')"
      [inViewportOptions]="{ threshold: [1000] }">
      <app-successtories *ngIf="componentInView.successtories"></app-successtories>
    </div>

    <div class="row call-to-action">
      <app-startfundraiser-button label="START A FUNDRAISER FOR FREE" pageName="home" info2="home_2"
        [width]="isMobile ? '100%' : '290px'" height="51px"></app-startfundraiser-button>
    </div>

    <div inViewport (inViewportAction)="loadComponent($event,'featuredin')" [inViewportOptions]="{ threshold: [1000] }">
      <app-featuredin *ngIf="componentInView.featuredin"></app-featuredin>
    </div>

  </div>
  <div *ngIf="isMobile">
    <app-landscape-view></app-landscape-view>
  </div>
</div>
<app-home-non-logged-in-v2 *ngIf="this.vwo.revamp_homepage_nonloggedin_AB()"></app-home-non-logged-in-v2>